import { getFullName } from "./get-full-name";

export interface ApplicantLike {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
}

export const getApplicantDisplayName = (applicant: ApplicantLike) => {
  const firstName = applicant.first_name ?? undefined;
  const lastName = applicant.last_name ?? undefined;
  const middleName = applicant.middle_name ?? undefined;

  if (firstName && lastName)
    return getFullName({
      firstName,
      lastName,
      middleName,
      short: true
    });

  return applicant.email;
};
